import type { ReactNode } from 'react';
import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { waadooIcons } from '../../ui/icons/waadooIcons';
import { SettingRow } from '../../waadooForm';

const LockedIcon = waadooIcons.locked;

/**
 * One row of a card of the « Configuration » tab (`SettingRow`,
 * components/waadooForm): its label and what it says under it, its inputs,
 * the lock when the caller may not change it, the reference's value
 * (« Comparer avec »), then its problems.
 */
export function ConfigurationRow(props: {
  label: string;
  labelId: string;
  children: ReactNode;
  hint?: ReactNode;
  reference?: ReactNode;
  locked?: boolean;
  lockedLabel: string;
  problems?: string[];
}) {
  return (
    <SettingRow
      label={props.label}
      labelId={props.labelId}
      hint={props.hint}
      reference={props.reference}
      problems={props.problems}
      action={
        props.locked ? (
          <TooltipTrigger>
            <ButtonIcon
              variant="tertiary"
              size="small"
              aria-label={props.lockedLabel}
              className="waadoo-config__lock"
              icon={<LockedIcon aria-hidden focusable="false" />}
            />
            <Tooltip>{props.lockedLabel}</Tooltip>
          </TooltipTrigger>
        ) : undefined
      }
    >
      {props.children}
    </SettingRow>
  );
}
